module.exports = __webpack_public_path__ + "static/img/jx-5.2e1dfa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jx-5.png
// module id = kwiH
// module chunks = 0